import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { GetTeamsQueryResult } from '@teams';
import { AppRoutes, TeamsRoutes } from '@core';
import { Router } from '@angular/router';
import { MemberRole } from '@core-http';

@Component({
  selector: 'lib-create-team',
  templateUrl: './create-team.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class CreateTeamComponent {
  private readonly router: Router = inject(Router);

  readonly teams: InputSignal<GetTeamsQueryResult[]> = input.required<GetTeamsQueryResult[]>();

  readonly isVisible: Signal<boolean> = computed(() => {
    const hostedTeams: GetTeamsQueryResult[] = this.teams().filter(
      (t: GetTeamsQueryResult) => t.memberRole === MemberRole.Host
    );
    return !hostedTeams.length;
  });

  createTeam(): void {
    this.router.navigateByUrl(`${AppRoutes.TEAMS}/${TeamsRoutes.CREATE}`);
  }
}
